import { apiAxios, firebaseAuth } from 'src/constants';
import { IFailedOrder } from '../data/interfaces/failed-order.interface';

export const fixFailedOrderUsecase = async (orders: IFailedOrder[]) => {
  try {
    const request = await apiAxios.post(
      'processFailedOrder',
      {
        orders
      },
      {
        headers: {
          Authorization: await firebaseAuth.currentUser?.getIdToken()
        }
      }
    );

    if (request.status !== 200)
      return { error: new Error('Bad request'), data: null };

    return { error: null, data: request.data };
  } catch (e) {
    console.error(e);
    return { error: e, data: null };
  }
};
